// This is a react application, the first thing we do is import react. 
import React from 'react';

// Import react-dom.
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

// Import global CSS
import './index.css';

// Import the pages that this website uses, these will be routed to through the dom-router
import ErrorPage from './routes/ErrorPage';
import LandingPage from './routes/LandingPage';
import SearchPage from './routes/SearchPage';
import ResultsPage from './routes/ResultsPage';
import PastSearchesPage from './routes/PastSearchesPage';
import VisualizeCSV from './components/results/VisualizeCSV';
import SearchNotFoundPage from './routes/SearchNotFoundPage';

// Define our routes. This governs how the url relates to which content is shown. 
const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage/>,
    errorElement: <ErrorPage/>,
  },
  {
    path: "/search",
    element: <SearchPage/>,
    errorElement: <ErrorPage/>,
  },
  {
    path: "/search/:id",
    element: <ResultsPage/>,
    errorElement: <ErrorPage/>,
  },
  {
    path: "/search_not_found/:id",
    element: <SearchNotFoundPage/>,
  },
  {
    path: "/api_communication_issue",
    element: <>
      API Communication Issue
    </>,
  },
  {
    path: "/searches",
    element: <PastSearchesPage/>,
    errorElement: <ErrorPage/>,
  },
]);

// Embed our React application in the webpage by binding the content to the "root" element.
const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <RouterProvider router={router} />
);